/**
 * Created by andrey on 08.08.2025
 */

cc.Spawn = function (...args) {
    cc.ActionInterval.prototype.constructor.call(this);

    const paramArray = (args[0] instanceof Array) ? args[0] : [...args];

    const actions = [];
    if (paramArray.length > 0) {
        actions.push(paramArray[0]);
    }
    if (paramArray.length > 1) {
        actions.push(paramArray[1]);
    }
    for (let i = 2; i < paramArray.length; i++) {
        actions[0] = cc.Spawn.fromArray([actions[0], actions[1]]);
        actions[1] = paramArray[i];
    }
    this.initWithActions(actions);
};

cc.Spawn.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.Spawn,

    initWithActions: function (actions) {
        if (actions.some((action) => !action)) {
            throw new Error("cc.Spawn action is undefined");
        }

        let ret = false;

        let maxDuration = 0;
        if (actions.length > 0) {
            maxDuration = Math.max.apply(null, actions.map((action) => action._duration));
        }

        if (this.initWithDuration(maxDuration)) {
            this._actions = actions;

            if (actions.length > 1) {
                const d1 = this._actions[0]._duration;
                const d2 = this._actions[1]._duration;

                if (d1 > d2) {
                    this._actions[1] = cc.Sequence.fromArray([this._actions[1], cc.delayTime(d1 - d2)]);
                } else if (d1 < d2) {
                    this._actions[0] = cc.Sequence.fromArray([this._actions[0], cc.delayTime(d2 - d1)]);
                }
            }

            ret = true;
        }
        return ret;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);

        for (let i = 0; i < this._actions.length; i++) {
            this._actions[i].startWithTarget(target);
        }
    },

    stop: function () {
        for (let i = 0; i < this._actions.length; i++) {
            this._actions[i].stop();
        }
        cc.Action.prototype.stop.call(this);
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);
        for (let i = 0; i < this._actions.length; i++) {
            this._actions[i].update(dt);
        }
    },

    _autoFinalize: function () {
        for (let i = 0; i < this._actions.length; i++) {
            this._actions[i]._autoFinalize();
        }
        this._elapsed = this._duration;
    }
});

cc.spawn = (...args) => {
    const paramArray = (args[0] instanceof Array) ? args[0] : [...args];
    if ((paramArray.length > 0) && (paramArray[paramArray.length - 1] == null)) {
        console.log("parameters should not be ending with null in Javascript");
    }

    let prev = paramArray[0];
    for (let i = 1; i < paramArray.length; i++) {
        if (paramArray[i] != null) {
            prev = cc.Spawn.fromArray([prev, paramArray[i]]);
        }
    }
    return prev;
};

cc.Spawn.fromArray = (actions) => {
    const pSpawn = new cc.Spawn();
    pSpawn.initWithActions(actions);
    return pSpawn;
};